import { Card, FlexCol, FlexRow, TabContent, TabProvider } from "@shared";

import { StakeTabButton } from "../../tab/StakeTabButton";
import { UscStakeForm } from "./form/stake/UscStakeForm";

import { UscEthStakeForm } from "./form/stake/UscEthStakeForm";
import { ChiEthStakeForm } from "./form/stake/ChiEthStakeForm";
import { UscUnstakeForm } from "./form/unstake/UscUnstakeForm";
import { UscEthUnstakeForm } from "./form/unstake/UscEthUnstakeForm";
import { ChiEthUnstakeForm } from "./form/unstake/ChiEthUnstakeForm";
import { UscEthBoostForm } from "./form/boost/UscEthBoostForm";
import { WithdrawForm } from "./form/withdraw/WithdrawForm";
import { ChiEthBoostForm } from "./form/boost/ChiEthBoostForm";
import { WstUscBoostForm } from "./form/boost/WstUscBoostForm";

import { useStakeContext } from "../../../../contexts/StakeProvider";
import { TabController } from "./TabController";

export const StakeComponent = () => {
  const {
    activeTab,
    stakeSelectedItem,
    setStakeSelectedItem,
    unstakeSelectedItem,
    setUnstakeSelectedItem,
    boostSelectedItem,
    setBoostSelectedItem,
    withdrawSelectedItem,
    setWithdrawSelectedItem,
  } = useStakeContext();

  return (
    <Card hasBorder>
      <FlexCol className="w-full p-4 gap-4">
        <TabProvider defaultTab={activeTab} overrideUrlSlug="stakeTab">
          <TabController />
          <FlexRow className="justify-between">
            <FlexRow className="w-full h-[44px] p-[4px] justify-between rounded-[16px] bg-neutral-black-10 ">
              <StakeTabButton tab="stake">Stake</StakeTabButton>
              <StakeTabButton tab="unstake">Unstake</StakeTabButton>
              <StakeTabButton tab="boost">Boost</StakeTabButton>
              <StakeTabButton tab="withdraw">Withdraw</StakeTabButton>
            </FlexRow>
          </FlexRow>
          <TabContent tab="stake">
            {stakeSelectedItem === "uscEth" && (
              <UscEthStakeForm
                selectedKey={stakeSelectedItem}
                onKeySelect={setStakeSelectedItem}
              />
            )}
            {stakeSelectedItem === "usc" && (
              <UscStakeForm
                selectedKey={stakeSelectedItem}
                onKeySelect={setStakeSelectedItem}
              />
            )}
            {stakeSelectedItem === "chiEth" && (
              <ChiEthStakeForm
                selectedKey={stakeSelectedItem}
                onKeySelect={setStakeSelectedItem}
              />
            )}
          </TabContent>
          <TabContent tab="unstake">
            {unstakeSelectedItem === "usc" && (
              <UscUnstakeForm
                selectedKey={unstakeSelectedItem}
                onKeySelect={setUnstakeSelectedItem}
              />
            )}
            {unstakeSelectedItem === "uscEth" && (
              <UscEthUnstakeForm
                selectedKey={unstakeSelectedItem}
                onKeySelect={setUnstakeSelectedItem}
              />
            )}
            {unstakeSelectedItem === "chiEth" && (
              <ChiEthUnstakeForm
                selectedKey={unstakeSelectedItem}
                onKeySelect={setUnstakeSelectedItem}
              />
            )}
          </TabContent>
          <TabContent tab="boost">
            {boostSelectedItem === "stUscEth" && (
              <UscEthBoostForm
                selectedKey={boostSelectedItem}
                onKeySelect={setBoostSelectedItem}
                setStakeSelectedItem={setStakeSelectedItem}
              />
            )}
            {boostSelectedItem === "stChiEth" && (
              <ChiEthBoostForm
                selectedKey={boostSelectedItem}
                onKeySelect={setBoostSelectedItem}
                setStakeSelectedItem={setStakeSelectedItem}
              />
            )}
            {boostSelectedItem === "wstUsc" && (
              <WstUscBoostForm
                selectedKey={boostSelectedItem}
                onKeySelect={setBoostSelectedItem}
              />
            )}
          </TabContent>
          <TabContent tab="withdraw">
            <WithdrawForm
              selectedKey={withdrawSelectedItem}
              onKeySelect={setWithdrawSelectedItem}
            />
          </TabContent>
        </TabProvider>
      </FlexCol>
    </Card>
  );
};
